<template lang="html">
  <Row
    type="flex"
    id="header"
    align="middle"
    :class="{
      'padding-50': !isMobile,
      'padding-16': isMobile,
      'header-tall': !isMobile,
      'header-short': isMobile,
      'dark-background': isMobile,
      'animate-header': atTopOfPage,
      }">

    <!--  Section 1 - Desktop -->
    <Col span="6" v-if="!isMobile">
      <Row type="flex" align="middle" justify="start">
        <router-link :to="{ name: 'Home' }">
          <Row type="flex" align="middle" justify="start">
            <img src="/static/logo-89x90.png" width="30px"></img>
            <h1 class="logo-text" :class="{ 'color-black': atTopOfPage }">Vue Finance</h1>
          </Row>
        </router-link>
      </Row>
    </Col>

        <!--  Section 1 - Mobile -->
    <Col span="13" v-if="isMobile">
      <Row type="flex" align="middle" justify="start">
        <router-link :to="{ name: 'Home' }">
          <Row type="flex" align="middle" justify="start">
            <img src="/static/logo-89x90.png" width="30px"></img>
            <h2 class="logo-text" :class="{ 'color-black': atTopOfPage }">Vue Finance</h2>
          </Row>
        </router-link>
      </Row>
    </Col>

    <!--  Section 2 - Desktop -->
    <Col span="2" v-if="!isMobile">
      <Row type="flex" align="middle" justify="center"></Row>
    </Col>

    <!-- Section 2 - Mobile -->
    <Col span="7" v-if="isMobile"></Col>

    <!--  Section 3 - Desktop -->
    <Col span="16" v-if="!isMobile">
      <Row type="flex" align="middle" justify="end">
        <Dropdown placement="bottom-end" class="nav-item" @on-visible-change="onDropdownChange" @on-click="navigate" trigger="click">
          <a class="nav-item" :class="{ 'color-black': atTopOfPage }">
            <h3>
              How it Works 
              <Icon type="ios-arrow-down" v-show="!productDropdownIsOpen"></Icon>
              <Icon type="ios-arrow-up" v-show="productDropdownIsOpen"></Icon>
            </h3>
          </a>
          <DropdownMenu slot="list" style="text-align: center;">
            <DropdownItem v-for="item in componentList" :name="item.card.title" :key="item.id">
              <Row type="flex" justify="start" align="middle">
                <router-link :to="{ name: item.route }" style="color: unset;">
                  <Icon :type="item.icon" :color="item.color" style="padding-right: 4px;"></Icon>
                  {{ item.card.title }}
                </router-link>
              </Row>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <router-link :to="{ name: 'Features' }" class="nav-item" :class="{ 'color-black': atTopOfPage }">
          <h3>Features</h3>
        </router-link>

        <router-link :to="{ name: 'Pricing' }" class="nav-item" :class="{ 'color-black': atTopOfPage }">
          <h3>Pricing</h3>
        </router-link>

<!--         <a :href="loginUrl" class="nav-item" :class="{ 'color-black': atTopOfPage }" style="margin-right: 8px;">
          <h3 class="fake-ghost-btn">Login</h3>
        </a>
 -->
        <GetStartedButton></GetStartedButton>
      </Row>
    </Col>

    <!--  Section 3 - Mobile -->
    <Col span="4" v-if="isMobile">
      <Row>
        <Dropdown @on-click="navigate" trigger="click" placement="bottom-end">
          <Button icon="navicon" shape="circle"></Button>
          <DropdownMenu slot="list">
            <DropdownItem>
              <router-link :to="{ name: 'Home' }" style="color: unset;">
                <h4>Home</h4>
              </router-link>
            </DropdownItem>
            <DropdownItem disabled><h4>How it Works</h4></DropdownItem>
            <DropdownItem v-for="item in componentList" :name="item.card.title" :key="item.id" style="margin-left: 8px;">
              <Row type="flex" justify="start" align="middle">
                <router-link :to="{ name: item.route }" style="color: unset;">
                  <Icon :type="item.icon" :color="item.color" style="padding-right: 4px;"></Icon>
                  {{ item.card.title }}
                </router-link>
              </Row>
            </DropdownItem>
            <DropdownItem>
              <router-link :to="{ name: 'Features' }" style="color: unset;">
                <h4>Features</h4>
              </router-link>
            </DropdownItem>
            <DropdownItem>
              <router-link :to="{ name: 'Pricing' }" style="color: unset;">
                <h4>Pricing</h4>
              </router-link>
            </DropdownItem>
<!--             <DropdownItem>
              <a :href="loginUrl" style="color: unset;">
                <h4>Login</h4>
              </a>
            </DropdownItem> -->
            <DropdownItem divided name="Get Early Access">
              <Row type="flex" justify="center">
                <GetStartedButton type="primary"></GetStartedButton>
              </Row>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Row>
    </Col>
  </Row>
</template>

<script>
import GetStartedButton from './GetStartedButton';
import pages from '../services/pages';
import platformComponents from '../services/platformComponents';

export default {
  props: ['isMobile', 'windowWidth'],
  components: { GetStartedButton },
  data() { return { loginUrl: process.env.LOGIN_URL, showModal: false, containerId: 'header', atTopOfPage: false, pages, productDropdownIsOpen: false, componentList: platformComponents }; },
  mounted() { window.addEventListener('scroll', this.handleScroll); },
  beforeDestroy() { window.removeEventListener('scroll', this.handleScroll); },
  created() { this.handleScroll(); },
  methods: {
    navigate(name) {
      const vm = this;
      if (name === 'Get Early Access') { return; }
      vm.$router.push({ name });
    },
    openModal() {
      this.showModal = true;
    },
    handleScroll() {
      if (window.scrollY > 40) {
        this.atTopOfPage = true;
      } else {
        this.atTopOfPage = false;
      }
    },
    onDropdownChange(state) {
      const vm = this;
      vm.productDropdownIsOpen = state;
    },
  },
};
</script>

<style lang="css" scoped>
@-webkit-keyframes solidifyHeader {
  0% {
    box-shadow: 0px 0px 10px rgba(0,0,0,0.02);
  }

  100% {
    background: rgba(255,255,255,0.94);
    box-shadow: 0px 0px 10px rgba(0,0,0,0.05);
    height: 62px;
  }
}

@-webkit-keyframes changeColorToBlack {
  100% {
    color: rgba(0,0,0,0.80);
  }
}

@-webkit-keyframes changeColorToBlue {
  100% {
    color: #3399ff;
  }
}

.animate-header {
  animation-name: solidifyHeader;
  animation-fill-mode: forwards;
  animation-duration: 0.8s;
  animation-timing-function: linear;
}

.color-black {
  animation-name: changeColorToBlack;
  animation-fill-mode: forwards;
  animation-duration: 0.8s;
  animation-timing-function: linear;
}

#header {
  position: fixed;
  top: 0;
  width: 100%;
  /*background: rgba(255,255,255,0.97);*/
  /* 
  z-index needs to be above Notification (2147483647), Messages (1010), and Poptip (1060)
  below Modal mask (1000)
  */
  z-index: 999;
}

.header-tall { height: 72px; }
.header-short { height: 62px; }

.dark-background {
  background: rgba(0, 0, 0, 0.04);
}

.logo-text {
  font-size: 22px;
  color: #fff;
  padding-left: 6px;
  padding-top: 4px;
}

.nav-item {
  margin-right: 16px;
  color: #fff;
}

.fake-ghost-btn {
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  padding: 4px 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/VueHeader.vue